import * as RadixNavigationMenu from "@radix-ui/react-navigation-menu";
import classNames from "classnames";

interface NavigationMenuProps {
  menuItems: {
    name: string;
    label: string | JSX.Element;
  }[];
  minimized?: boolean;
}

export function NavigationMenu({
  menuItems,
  minimized = false,
}: NavigationMenuProps) {
  return (
    <RadixNavigationMenu.Root>
      <RadixNavigationMenu.List
        className={classNames("flex flex-col", { "items-center": minimized })}
      >
        {menuItems.map((menuItems) => (
          <RadixNavigationMenu.Item key={menuItems.name}>
            {menuItems.label}
          </RadixNavigationMenu.Item>
        ))}
      </RadixNavigationMenu.List>
    </RadixNavigationMenu.Root>
  );
}
